import { di } from 'react-magnetic-di';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type HookActionsFunction,
	type Action,
	createHook,
	createStore,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import { useIsClientReady } from '@atlassian/jira-ssr-toolkit/src/hooks/use-is-client-ready.tsx';
import { BANNER_HEIGHT } from '../../constants.tsx';
import type { State } from './types.tsx';

/**
 * @deprecated Don't do __SERVER__ checks, use `useIsInIframe`
 */
export const isInIframe = () => {
	di(window);
	if (__SERVER__) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
};

export function useIsInIframe() {
	di(window);
	const isClientRender = useIsClientReady();

	if (!isClientRender) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
}

// Fetching banner preferences and height in initial state to prevent layout shifts.
export const initialState: State = {
	get isDismissed() {
		return true;
	},
	get height() {
		return BANNER_HEIGHT;
	},
	hasInit: false,
};

export const actions = {
	onShow:
		(): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed: false,
			});
		},
	onDismiss:
		(): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed: true,
			});
		},
	setHeight:
		(height: number): Action<State> =>
		({ setState }) => {
			setState({ height });
		},
	init:
		(isDismissed: boolean): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed,
				hasInit: true,
			});
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'cookie-consent-banner',
	initialState,
	actions,
});

export const useCookieConsentBannerSettings = createHook(Store);

// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>>' is not assignable to type 'HookActionsFunction<{ readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>'.
export const useCookieConsentBannerSettingsActions: HookActionsFunction<Actions> =
	createActionsHook(Store);
